import { getStates } from '@/services/api/states';

const state = () => ({
  states: [],
})

const mutations = {
  SET_STATES(state, states) {
    state.states = states;
  }
}

const actions = {
  updateStates({ commit }) {
    return getStates()
      .then(resp => {
        commit('SET_STATES', resp)
        return Promise.resolve();
      })
      .catch(err => {
        return Promise.reject(err);
      })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}